import React from 'react';
import { Box, CardContent, Typography, Chip } from '@mui/material';
import { EventNote as EventIcon } from '@mui/icons-material';
import { C, tEType, tStatus } from './constants';
import { GlowCard, eventStatusColor } from './ui';
import { eventStatusColor as getColor } from './utils';

/**
 * EventsCard — shows up to 5 events with status chips.
 *
 * Props:
 *   events — array of event objects
 */
const EventsCard = ({ events = [], delay = 0 }) => (
  <GlowCard delay={delay} accent="#A78BFA" sx={{ height: '100%' }}>
    <CardContent sx={{ p: 3 }}>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2.5 }}>
        <EventIcon sx={{ color: '#A78BFA', fontSize: 20 }} />
        <Typography sx={{ fontFamily: 'Syne', fontWeight: 700, color: C.text, fontSize: '1rem' }}>
          Évènements
        </Typography>
      </Box>

      {events.length === 0 ? (
        <Typography sx={{ fontFamily: 'DM Sans', color: C.muted, fontSize: '0.85rem' }}>
          Aucun évènement trouvé.
        </Typography>
      ) : (
        events.slice(0, 5).map((ev, i) => {
          const statusColor = getColor(ev.status, C);
          return (
            <Box key={ev._id} sx={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              py: 1.2,
              borderBottom: i < Math.min(events.length, 5) - 1 ? `1px solid ${C.border}` : 'none',
              animation: `fadeUp 0.4s ease both`,
              animationDelay: `${i * 55 + delay}ms`,
            }}>
              <Box sx={{ minWidth: 0 }}>
                <Typography noWrap sx={{ fontFamily: 'DM Sans', fontWeight: 500, color: C.text, fontSize: '0.85rem' }}>
                  {ev.name}
                </Typography>
                <Typography sx={{ fontFamily: 'DM Sans', color: C.muted, fontSize: '0.72rem' }}>
                  {tEType(ev.type)} · {ev.games?.length || 0} match{ev.games?.length > 1 ? 's' : ''}
                </Typography>
              </Box>
              <Chip
                label={tStatus(ev.status)} size="small"
                sx={{
                  ml: 1, flexShrink: 0,
                  background: `${statusColor}18`,
                  border: `1px solid ${statusColor}40`,
                  color: statusColor,
                  fontFamily: 'DM Sans', fontSize: '0.68rem',
                }}
              />
            </Box>
          );
        })
      )}

    </CardContent>
  </GlowCard>
);

export default EventsCard;
